<template>
    <div id="system_param_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="termHeader" v-if="$route.params.id > 0">Update System Param</span>
                    <span class="page-title" id="termHeader" v-else>Add System Param</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="backSystemParam" >
                        <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content term-crud">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container metric-form" id="systemParamForm">
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label require" for="name">Name:</label>
                                        <input type="text" class="form-control" v-model="name" id="name" placeholder="Enter Name" name="name" :disabled="true">
                                        <div class="field-error">{{name_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="Term">Value:</label>
                                        <input type="text"  class="form-control" v-model="value" id="value" placeholder="Enter Value" name="value" >
                                        <div class="field-error">{{value_error_msg}}</div>
                                    </div>

                                </div>
                                <div class="form-group">
                                    <div class="alert alert-warning hide offset-col-2 col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                                <div class="btn-groups">
                                    <button type="submit" id="CreateSystemParamsBtn" v-if="$route.params.id > 0" class="btn btn-primary" v-on:click.prevent="CreateSystemParam" >
                                    <i class="fp-reload"> </i>  Update
                                    </button>
                                    <!-- <button type="submit" id="CreateTermBtn" v-else class="btn btn-primary" v-on:click.prevent="CreateTerm" >
                                    <i class="fp-save"> </i>  Save
                                    </button> -->
                                    <!-- <button type="submit" id="createAndContinueTermBtn" v-if="$route.params.id == undefined" class="btn btn-tertiary" v-on:click.prevent="CreateTerm(flag='Save and Continue')" >
                                    <i class="fp-save-continue"> </i>  Save and Continue
                                    </button> -->
                                    <button type="submit" id="cancelSystemParamsBtn" class="btn btn-tertiary" v-on:click.prevent="backSystemParam" >
                                    <i class="fp-close"> </i>  Cancel
                                    </button>
                                </div>
                            </form>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';


export default {
  name: "TermCreate",
  
  metaInfo() {
      return {title: (this.$route.params.id > 0)? "Update System Param | " +process.env.COPYRIGHT_NAME : "Create System Param | " +process.env.COPYRIGHT_NAME}
  },
  mixins:[commonMixins],
  data: () => ({
    permissions: [],
    cantAccessPage: "",
    name: "",
    loading:false,
    name_error_msg: "",
    value_error_msg: "",
    value:'',
  }),
  watch:{

        //check permission change
        permissions: function (permissions) {

            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_term') {
                        self.cantAccessPage = true;
                    }
                }
            }

        }
   },
  created: function() {

  },
  mounted: function() {
        var self = this;
        self.getPermissions();

        setTimeout(function () {
            var path = window.location.pathname;
            var segments = path.split("/");

            if (segments[3]) {
                self.loadSystemParam();
            }
        }, 100);
  },
  methods: {
    backSystemParam() {
      var self = this;
      self.$router.push("/system-param/list");
    },

    CreateSystemParam() {
      var self = this;

      self.value = self.value.trim();
      self.name = self.name.trim();

      self.name_error_msg = "";
      self.value_error_msg = "";

      if (!self.name || self.name == null || self.name == "") {
        self.name_error_msg = "Name Required.";
      }

      if (!self.value || self.value == '' || self.value == 0) {
        self.term_error_msg = "Value Required.";
      }


      if (self.name_error_msg == "" && self.value_error_msg == "" ) {
            self.loading = true;
            var path = window.location.pathname;
            var segments = path.split("/");

            $.ajax({
                url: process.env.ROOT_API + "/system-param/create",
                type: "POST",
                data: {name: self.name, id: segments[3], value: self.value},
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;

                    if (data.status == "success") {

                        // if (flag == "Save and Continue") {

                        //     $("#systemParamForm").trigger("reset");
                        //     self.name ="";
                        //     self.value = "";

                        // }else{
                            self.$router.push("/system-param/list");
                        // }

                    } else {
                        if (data.content.length > 0) {
                            var err = "";
                            for (var i = 0; i < data.content.length; i++) {
                                err += data.content[i] + "<br>";
                            }
                            $("#errorMsg").html(err);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'term-create')
                }
            });
      }else{
          self.errorValidationFocus();
      }

    },

    loadSystemParam() {
        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/system-param/" + segments[3],
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            data:{
                id:segments[3]
            },
            success: function (data) {
                self.loading = false;
                console.log(data);
                if (data.status == "success") {
                    self.name = data.content.param_key;
                    self.value = data.content.param_value;
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'term-load-by-id')
            }
        });
    },
    titleCase(str) {
            if (str == null) {
                return;
            } else {
                var value = str.toString()
                return value.charAt(0).toUpperCase() + value.slice(1)
            }
        },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/SystemParamCreate.vue